import { MessageSquare, LayoutDashboard, Sparkles, LucideIcon } from "lucide-react";
import { buildPortalUrl } from "../../utils/url";

export interface PricingFeature {
    title: string;
    description?: string;
}

export interface PricingGroup {
    title: string;
    subtitle: string;
    features: PricingFeature[];
    icon: LucideIcon;
}

export const PRICING_GROUPS: PricingGroup[] = [
    {
        title: "Patient Access",
        subtitle: "Focus on how easy it is for patients to reach you.",
        icon: MessageSquare,
        features: [
            {
                title: "Instant WhatsApp Booking",
                description: "Patients book, reschedule, or cancel visits directly via chat."
            },
            {
                title: "QR Codes",
                description: "Scan-to-book access from your front desk, posters, or website."
            }
        ]
    },
    {
        title: "Clinic Control",
        subtitle: "Focus on the tools the doctor or staff use daily.",
        icon: LayoutDashboard,
        features: [
            {
                title: "Professional Website",
                description: "Launch a professional clinic website with services, maps, and branding."
            },
            {
                title: "Live Dashboard",
                description: "View all appointments and patient data in one place."
            },
            {
                title: "Multi-Staff Access",
                description: "Give reception staff their own logins with controlled access."
            }
        ]
    },
    {
        title: "Smart Automations",
        subtitle: "Focus on the background magic that saves time.",
        icon: Sparkles,
        features: [
            {
                title: "Zero-Effort Confirmations",
                description: "Instant WhatsApp alerts for every new booking."
            },
            {
                title: "No-Show Protection",
                description: "Automatic reminders sent before every visit."
            },
            {
                title: "Reputation Builder",
                description: "Automated feedback collection after appointments."
            },
            {
                title: "Follow-up Care",
                description: "Auto-messages for check-ups or recurring treatments."
            }
        ]
    }
];

export const PRICING_START_TRIAL_CTA = buildPortalUrl({ mode: "register", content: "pricing_start_trial" });
